// google_ads_helper.js

export const GOOGLE_ADS_PURCHASE_INSTAMOJO_SEND_TO =
  "AW-939977658/KO3rCKnex8kcELrXm8AD";

export const GOOGLE_ADS_PURCHASE_PADDLE_SEND_TO =
  "AW-939977658/aDVRCOS_sckcELrXm8AD";

export const GOOGLE_ADS_INSTAMOJO_DEFAULT_AMOUNT = 1560;

export const GOOGLE_ADS_PADDLE_DEFAULT_AMOUNT = 3000;

function isBrowser() {
  try {
    return typeof window !== "undefined";
  } catch (e) {
    console.log("[GoogleAdsHelper] isBrowser failed", e);
    return false;
  }
}

function logGoogleAdsEvent(eventName, data) {
  try {
    console.log("[GoogleAdsHelper]", eventName, data || {});
  } catch (e) {
    // Do nothing. Logging should never break app functionality.
  }
}

function logGoogleAdsException(eventName, e, data) {
  try {
    console.log("[GoogleAdsHelper]", eventName, data || {}, e);
  } catch (ignored) {
    // Do nothing. Logging should never break app functionality.
  }
}

function sendGoogleAdsConversion({
  sendTo,
  amount,
  currency = "INR",
  transactionId,
}) {
  try {
    if (!isBrowser()) {
      logGoogleAdsEvent("google_ads_conversion_skipped_not_browser");
      return false;
    }

    if (!window.gtag) {
      logGoogleAdsEvent("google_ads_conversion_skipped_gtag_missing");
      return false;
    }

    if (!sendTo) {
      logGoogleAdsEvent("google_ads_conversion_skipped_send_to_missing");
      return false;
    }

    if (!transactionId) {
      logGoogleAdsEvent("google_ads_conversion_skipped_transaction_id_missing", {
        sendTo,
        amount,
      });
      return false;
    }

    const numericAmount = Number(amount);

    if (
      amount === undefined ||
      amount === null ||
      amount === "" ||
      Number.isNaN(numericAmount) ||
      numericAmount <= 0
    ) {
      logGoogleAdsEvent("google_ads_conversion_skipped_invalid_amount", {
        sendTo,
        amount,
        transactionId,
      });
      return false;
    }

    const payload = {
      send_to: sendTo,
      value: numericAmount,
      currency,
      transaction_id: String(transactionId),
    };

    window.gtag("event", "conversion", payload);

    logGoogleAdsEvent("google_ads_conversion_sent", {
      sendTo,
      amount: numericAmount,
      currency,
      transactionId: String(transactionId),
    });

    return true;
  } catch (e) {
    logGoogleAdsException("sendGoogleAdsConversion_failed", e, {
      sendTo,
      amount,
      currency,
      transactionId,
    });

    return false;
  }
}

export function captureInstamojoGoogleAdsConversion(
  transactionId,
  amount = GOOGLE_ADS_INSTAMOJO_DEFAULT_AMOUNT
) {
  try {
    return sendGoogleAdsConversion({
      sendTo: GOOGLE_ADS_PURCHASE_INSTAMOJO_SEND_TO,
      amount,
      currency: "INR",
      transactionId,
    });
  } catch (e) {
    logGoogleAdsException("captureInstamojoGoogleAdsConversion_failed", e, {
      transactionId,
      amount,
    });

    return false;
  }
}

export function capturePaddleGoogleAdsConversion(
  transactionId,
  amount = GOOGLE_ADS_PADDLE_DEFAULT_AMOUNT
) {
  try {
    return sendGoogleAdsConversion({
      sendTo: GOOGLE_ADS_PURCHASE_PADDLE_SEND_TO,
      amount,
      currency: "INR",
      transactionId,
    });
  } catch (e) {
    logGoogleAdsException("capturePaddleGoogleAdsConversion_failed", e, {
      transactionId,
      amount,
    });

    return false;
  }
}